import { Box, Card, Tooltip, Typography } from '@mui/material';
import {
  AUDIO_RESOURCES_ICON,
  DOC_RESOURCES_ICON,
  LIKE_HEART_ICON,
  LIKE_ICON,
  PDF_RESOURCES_ICON,
  PPT_RESOURCES_ICON,
  XLS_RESOURCES_ICON
} from '../../utils/imageUrls';
import {
  colorPureWhite,
  colorTextBlack,
  colorTextGrey
} from '../../config/theme';
import { VisibilityOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import MoreActionsComponent from './MoreActionsComponent';
import {
  addContentViews,
  addHistory,
  deleteGamification,
  gamification,
  updateLikeDislike
} from '../../redux/reducers/resourcesSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { formatDateTimeAgo } from '../../utils/utils';

const ContentCards = ({ video, sectionId, tags, path }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { authData } = useSelector(state => state.auth);

  const handleOnClick = (
    encryptedContentId,
    sectionId,
    contentId,
    contentType
  ) => {
    let payload = {
      contentId: contentId || 0,
      userId: authData?.userId || 0,
      loggedInUserName: authData?.userName || ''
    };
    dispatch(addHistory({ payload }));
    // if (contentType !== 'Video' && contentType !== 'Audio') {
    //   dispatch(addContentViews({ payload }));
    // }

    navigate(
      `/content-space/view?id=${encryptedContentId}&sectionId=${sectionId}`,
      {
        state: {
          tags: tags,
          path: path || ''
        }
      }
    );
  };

  const handleLikeDislike = (e, video) => {
    e.stopPropagation();

    let LikePayload = {
      contentId: video?.content_id || 0,
      loggedInUserName: authData?.userName || ''
    };

    let disLikePayload = {
      contentId: video?.content_id || 0,
      loggedInUserName: authData?.userName || '',
      userId: authData?.userId || 0
    };

    let payload = video?.contentLikes === 'No' ? LikePayload : disLikePayload;
    let contentLike = video?.contentLikes;

    dispatch(updateLikeDislike({ payload, contentLike }));
    // if (authData?.role === 'I am a student') {
    //   if (video?.allow_points && video?.contentLikes === 'Yes') {
    //     let payload = {
    //       userId: authData?.userId || 0,
    //       contentId: video?.content_id || 0,
    //       loggedInUserName: authData?.userName || ''
    //     };
    //     dispatch(deleteGamification({ payload }));
    //   }

    //   if (video?.allow_points && video?.contentLikes === 'No') {
    //     let gamificationPayload = {
    //       userId: authData?.userId || 0,
    //       contentId: video?.content_id || 0,
    //       point: video?.likes_points || 0,
    //       type: 'like',
    //       loggedInUserName: authData?.userName || ''
    //     };
    //     dispatch(gamification({ gamificationPayload }));
    //   }
    // }
  };

  return (
    <>
      {video?.upload_type === 'Video' || video?.upload_type === 'Image' ? (
        <Card
          sx={{
            boxShadow: 'none',
            position: 'relative',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            flex: 1
          }}
        >
          <div style={{ display: 'flex' }}>
            <div
              style={{
                flex: '0 0 50%',
                borderRadius: '6px',
                overflow: 'hidden'
              }}
              onClick={() =>
                handleOnClick(
                  video?.encrypted_content_id,
                  sectionId,
                  video?.content_id,
                  video?.upload_type
                )
              }
            >
              <img
                src={
                  video?.upload_type === 'Video'
                    ? video.thumbnail_file_url
                    : video?.content_file_url
                }
                alt={video.title}
                style={{
                  width: '100%',
                  height: '140px'
                }}
              />
            </div>

            <div style={{ flex: '0 0 50%' }}>
              <div style={{ display: 'flex' }}>
                <div
                  onClick={() =>
                    handleOnClick(
                      video?.encrypted_content_id,
                      sectionId,
                      video?.content_id,
                      video?.upload_type
                    )
                  }
                >
                  <div
                    style={{
                      marginLeft: '-35px',
                      marginTop: '7px',
                      width: '26px',
                      height: '26px',
                      backgroundColor: 'rgba(255, 255, 255, 0.7)',
                      borderRadius: '50%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer'
                    }}
                    onClick={e => handleLikeDislike(e, video)}
                  >
                    <img
                      className="imgbox"
                      src={
                        video?.contentLikes === 'Yes'
                          ? LIKE_HEART_ICON
                          : LIKE_ICON
                      }
                      alt="Like Icon"
                      width={15}
                      height={15}
                      style={{
                        cursor: 'pointer'
                      }}
                    />
                  </div>

                  {video?.upload_type === 'Video' && (
                    <div
                      style={{
                        marginLeft: '-45px',
                        marginTop: '70px',
                        padding: '0.5px',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: colorTextBlack,
                          borderRadius: '4px'
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: '10px',
                            fontWeight: 600,
                            fontFamily: 'Lato',
                            color: colorPureWhite,
                            padding: '5px'
                          }}
                        >
                          {video?.duration || '00:00'}
                        </Typography>
                      </div>
                    </div>
                  )}
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '12px',
                    width: '100%'
                  }}
                >
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        fontFamily: 'Lato',
                        fontSize: '16px',
                        display: '-webkit-box',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        lineHeight: '20px'
                      }}
                      onClick={() =>
                        handleOnClick(
                          video?.encrypted_content_id,
                          sectionId,
                          video?.content_id,
                          video?.upload_type
                        )
                      }
                    >
                      {video?.title || ''}
                    </Typography>
                    <div style={{ marginLeft: '10px' }}>
                      <MoreActionsComponent data={video} path={path} />
                    </div>
                  </div>

                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      color: '#ABB4BD',
                      gap: 1,
                      fontWeight: 500,
                      fontFamily: 'Lato',
                      fontSize: '14px',
                      lineHeight: '18px',
                      marginTop: '10px'
                    }}
                    onClick={() =>
                      handleOnClick(
                        video?.encrypted_content_id,
                        sectionId,
                        video?.content_id,
                        video?.upload_type
                      )
                    }
                  >
                    <VisibilityOutlined fontSize="small" />
                    <Typography
                      style={{
                        fontSize: '14px',
                        fontFamily: 'Lato',
                        lineHeight: '18px',
                        fontWeight: 500,
                        color: colorTextGrey
                      }}
                    >
                      {video?.views || 0}
                    </Typography>

                    <Typography
                      style={{
                        fontSize: '14px',
                        fontFamily: 'Lato',
                        lineHeight: '18px',
                        fontWeight: 500,
                        color: colorTextGrey
                      }}
                    >
                      •
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '14px',
                        fontFamily: 'Lato',
                        lineHeight: '18px',
                        fontWeight: 500,
                        color: colorTextGrey
                      }}
                    >
                      {video.updated_dt
                        ? formatDateTimeAgo(video.updated_dt)
                        : '-'}
                    </Typography>
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </Card>
      ) : video?.upload_type === 'POWERPOINT' ||
        video?.upload_type === 'MSWORD' ||
        video?.upload_type === 'EXCEL' ||
        video?.upload_type === 'PDF' ? (
        <>
          <Card
            sx={{
              boxShadow: 'none',
              position: 'relative',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              flex: 1
            }}
          >
            <div style={{ display: 'flex' }}>
              <div
                style={{
                  flex: '0 0 50%',
                  border: '1px solid #CBD2D9',
                  borderRadius: '6px',
                  overflow: 'hidden'
                }}
                onClick={() =>
                  handleOnClick(
                    video?.encrypted_content_id,
                    sectionId,
                    video?.content_id,
                    video?.upload_type
                  )
                }
              >
                <img
                  src={
                    video?.upload_type === 'POWERPOINT'
                      ? PPT_RESOURCES_ICON
                      : video?.upload_type === 'MSWORD'
                        ? DOC_RESOURCES_ICON
                        : video?.upload_type === 'EXCEL'
                          ? XLS_RESOURCES_ICON
                          : video?.upload_type === 'PDF'
                            ? PDF_RESOURCES_ICON
                            : PPT_RESOURCES_ICON
                  }
                  alt={video.title}
                  style={{
                    width: '100%',
                    height: '140px'
                  }}
                />
              </div>

              <div style={{ flex: '0 0 50%' }}>
                <div style={{ display: 'flex' }}>
                  <div
                    onClick={() =>
                      handleOnClick(
                        video?.encrypted_content_id,
                        sectionId,
                        video?.content_id,
                        video?.upload_type
                      )
                    }
                  >
                    <div
                      style={{
                        marginLeft: '-35px',
                        marginTop: '7px',
                        width: '26px',
                        height: '26px',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer'
                      }}
                      onClick={e => handleLikeDislike(e, video)}
                    >
                      <img
                        className="imgbox"
                        src={
                          video?.contentLikes === 'Yes'
                            ? LIKE_HEART_ICON
                            : LIKE_ICON
                        }
                        alt="Like Icon"
                        width={15}
                        height={15}
                        style={{
                          cursor: 'pointer'
                        }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      padding: '12px',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 700,
                          fontFamily: 'Lato',
                          fontSize: '16px',
                          display: '-webkit-box',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          lineHeight: '20px'
                        }}
                        onClick={() =>
                          handleOnClick(
                            video?.encrypted_content_id,
                            sectionId,
                            video?.content_id,
                            video?.upload_type
                          )
                        }
                      >
                        {video?.title || ''}
                      </Typography>
                      <div style={{ marginLeft: '10px' }}>
                        {/* <MoreVertIcon /> */}
                        <MoreActionsComponent data={video} path={path} />
                      </div>
                    </div>

                    {/* <Typography
                      color={colorLinkGrey}
                      sx={{
                        marginBottom: 1,
                        fontWeight: 600,
                        fontFamily: 'Lato',
                        fontSize: '14px',
                        lineHeight: '18px',
                        marginTop: '10px'
                      }}
                      onClick={() =>
                        handleOnClick(video?.encrypted_content_id, sectionId)
                      }
                    >
                      {video?.created_by || ''}
                    </Typography> */}

                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        color: '#ABB4BD',
                        gap: 1,
                        fontWeight: 500,
                        fontFamily: 'Lato',
                        fontSize: '14px',
                        lineHeight: '18px',
                        marginTop: '10px'
                      }}
                      onClick={() =>
                        handleOnClick(
                          video?.encrypted_content_id,
                          sectionId,
                          video?.content_id,
                          video?.upload_type
                        )
                      }
                    >
                      <VisibilityOutlined fontSize="small" />
                      <Typography
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Lato',
                          lineHeight: '18px',
                          fontWeight: 500,
                          color: colorTextGrey
                        }}
                      >
                        {video?.views || 0}
                      </Typography>

                      <Typography
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Lato',
                          lineHeight: '18px',
                          fontWeight: 500,
                          color: colorTextGrey
                        }}
                      >
                        •
                      </Typography>
                      <Typography
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Lato',
                          lineHeight: '18px',
                          fontWeight: 500,
                          color: colorTextGrey
                        }}
                      >
                        {video.updated_dt
                          ? formatDateTimeAgo(video.updated_dt)
                          : '-'}
                      </Typography>
                    </Box>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </>
      ) : video?.upload_type === 'Audio' ? (
        <>
          <Card
            sx={{
              boxShadow: 'none',
              position: 'relative',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              flex: 1
            }}
          >
            <div style={{ display: 'flex' }}>
              <div
                style={{
                  flex: '0 0 50%',
                  border: '1px solid #CBD2D9',
                  borderRadius: '6px',
                  overflow: 'hidden'
                }}
                onClick={() =>
                  handleOnClick(
                    video?.encrypted_content_id,
                    sectionId,
                    video?.content_id,
                    video?.upload_type
                  )
                }
              >
                <img
                  src={AUDIO_RESOURCES_ICON}
                  alt={video.title}
                  style={{
                    width: '100%',
                    height: '140px'
                  }}
                />
              </div>

              <div style={{ flex: '0 0 50%' }}>
                <div style={{ display: 'flex' }}>
                  <div
                    onClick={() =>
                      handleOnClick(
                        video?.encrypted_content_id,
                        sectionId,
                        video?.content_id,
                        video?.upload_type
                      )
                    }
                  >
                    <div
                      style={{
                        marginLeft: '-35px',
                        marginTop: '7px',
                        width: '26px',
                        height: '26px',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer'
                      }}
                      onClick={e => handleLikeDislike(e, video)}
                    >
                      <img
                        className="imgbox"
                        src={
                          video?.contentLikes === 'Yes'
                            ? LIKE_HEART_ICON
                            : LIKE_ICON
                        }
                        alt="Like Icon"
                        width={15}
                        height={15}
                        style={{
                          cursor: 'pointer'
                        }}
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      padding: '12px',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 700,
                          fontFamily: 'Lato',
                          fontSize: '16px',
                          display: '-webkit-box',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          lineHeight: '20px'
                        }}
                        onClick={() =>
                          handleOnClick(
                            video?.encrypted_content_id,
                            sectionId,
                            video?.content_id,
                            video?.upload_type
                          )
                        }
                      >
                        {video?.title || ''}
                      </Typography>
                      <div style={{ marginLeft: '10px' }}>
                        <MoreActionsComponent data={video} path={path} />
                      </div>
                    </div>

                    {/* <Typography
                      color={colorLinkGrey}
                      sx={{
                        marginBottom: 1,
                        fontWeight: 600,
                        fontFamily: 'Lato',
                        fontSize: '14px',
                        lineHeight: '18px',
                        marginTop: '10px'
                      }}
                      onClick={() =>
                        handleOnClick(video?.encrypted_content_id, sectionId)
                      }
                    >
                      {video?.created_by || ''}
                    </Typography> */}

                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        color: '#ABB4BD',
                        gap: 1,
                        fontWeight: 500,
                        fontFamily: 'Lato',
                        fontSize: '14px',
                        lineHeight: '18px',
                        marginTop: '10px'
                      }}
                      onClick={() =>
                        handleOnClick(
                          video?.encrypted_content_id,
                          sectionId,
                          video?.content_id,
                          video?.upload_type
                        )
                      }
                    >
                      <VisibilityOutlined fontSize="small" />
                      <Typography
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Lato',
                          lineHeight: '18px',
                          fontWeight: 500,
                          color: colorTextGrey
                        }}
                      >
                        {video?.views || 0}
                      </Typography>

                      <Typography
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Lato',
                          lineHeight: '18px',
                          fontWeight: 500,
                          color: colorTextGrey
                        }}
                      >
                        •
                      </Typography>
                      <Typography
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Lato',
                          lineHeight: '18px',
                          fontWeight: 500,
                          color: colorTextGrey
                        }}
                      >
                        {video.updated_dt
                          ? formatDateTimeAgo(video.updated_dt)
                          : '-'}
                      </Typography>
                    </Box>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </>
      ) : (
        <> </>
      )}
    </>
  );
};

export default ContentCards;
